export { customEasings, motionEasings } from "./EasingFunctions";

const convertStringToNumber = (number) => (typeof number == "number" ? number : parseFloat(number));
const numberIfFloat = (input) =>
    input == null || ("" + input).trim() === "" || isNaN(+input) ? false : convertStringToNumber(input);

export function injectCSS(css) {
    if (!css) {
        return;
    }
    const element = document.createElement("style");
    element.innerText = css;
    document.head.appendChild(element);
    return element;
}

export function dispatchEvent(element, type, detail) {
    element.dispatchEvent(new CustomEvent(`animation:${type}`, { detail, bubbles: true, cancelable: true }));
}

function stringToValueAndUnit(input) {
    if (typeof input === "number") {
        return [input, null];
    }
    const match = input.match(/(\d*\.?\d)(\D*)/);
    if (!match) {
        return [0, null];
    }
    const number = parseFloat(match[1]);
    const unit = match[2];
    if (unit === "%") {
        return [number / 100, null];
    }
    if (!unit) {
        return [number, null];
    }
    return [number, unit];
}

export function getOffsetForScroll(input) {
    switch (input) {
        case "start":
            return [0, null];
        case "center":
            return [0.5, null];
        case "end":
            return [1, null];
    }
    const float = numberIfFloat(input);
    if (float !== false) {
        return [float, null];
    }
    return stringToValueAndUnit(input);
}

export function getOffsetForScrollFunctionForStagger({ offsetValue, offsetUnit, stagger, section }) {
    if (stagger === true) {
        if (offsetUnit) {
            const lastElementValue = offsetValue;
            return (index, numberOfElements) => {
                const start = index ? `${index * (lastElementValue / (numberOfElements - 1 || 1))}${offsetUnit}` : 1;
                return [
                    [0, 1],
                    [start, 1],
                ];
            };
        }

        let lastElementAddedValue = 0.5;
        if (offsetValue > 1) {
            lastElementAddedValue = offsetValue - 1;
            offsetValue = 1;
        }
        return (index, numberOfElements) => {
            const start = index * (lastElementAddedValue / (numberOfElements - 1 || 1)) + offsetValue;
            return [
                [0, 1],
                [start, 1],
            ];
        };
    }

    const [staggerOffset, staggerUnit] = stringToValueAndUnit(stagger);
    if (offsetUnit && staggerUnit && offsetUnit !== staggerUnit) {
        console.error(
            `The unit of the stagger (${staggerUnit}) and the offset (${offsetUnit}) must be the same`,
            section,
        );
        return;
    }
    const unit = offsetUnit || staggerUnit;

    // ["start end", "end end"] is the same as [[0, 1], [1, 1]]
    if (!unit) {
        return (index) => [
            [0, 1],
            [index * staggerOffset + offsetValue, 1],
        ];
    }

    return (index) => [
        [0, 1],
        [`${index * staggerOffset + offsetValue}${unit}`, 1],
    ];
}

export function observeForChanges(callback, element, once = false) {
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver((mutationList, overserver) => {
        mutationList.forEach((mutation) => {
            if (mutation.type === "childList") {
                callback(mutation);
                if (once) {
                    overserver.disconnect();
                }
            }
        });
    });

    // Start observing the target node for configured mutations
    observer.observe(element, {
        attributes: false,
        childList: true,
        subtree: false,
    });
}
